import {QA, SectionDivider} from "src/components/v5/Faq/Faq";
import {useFaqIndex} from "src/hooks/useFaqIndex";

export const PHONE_NUMBERS = {
  REASON: "(415) 877-9821",
  MAIN: "1 833-440-2726",
};

const useInsurancePricingConstants = (): {
  faq: (QA | SectionDivider)[];
} => {
  const faq = useFaqIndex([
    "How much does COVID-19 testing, treatment, and vaccines cost?",
    "Do you accept insurance?",
    "How much will my co-pay be?",
    "What are co-pays? What are deductibles?",
    "What does it mean if my insurance is not verified?",
    "How do I add my insurance if I'm on my family's plan?",
    "When will I get my bill?",
    "My credit card was charged by 'direct urgent care'",
  ]);

  return {
    faq,
  };
};

export default useInsurancePricingConstants;
